import React from "react";
import styles from "../css/style";
import {
  Navbar,
  Hero,
  Stats,
  Business,
  CardDeal,
  Testimonials,
  Clients,
  CTA,
  Footer,
} from "../components/LandingPage";

const LandingPage = () => {
  return (
    <>
      <div className={`${styles.paddingX} ${styles.flexCenter} w-full overflow-hidden`}>
        <div className={`${styles.boxWidth}`}>
          {/* Navbar without onlyAuth prop to display Hjem, Blog, Log ind, Opret bruger */}
          <Navbar />
        </div>
      </div>
      <div className="bg-primary w-full overflow-hidden">
        <div className={`bg-primary ${styles.flexStart}`}>
          <div className={`${styles.boxWidth}`}>
            <Hero />
          </div>
        </div>

        <div className={`bg-primary ${styles.paddingX} ${styles.flexCenter}`}>
          <div className={`${styles.boxWidth}`}>
            <Stats />
            <Business />
            <CardDeal />
            <Testimonials />
            <Clients />
            <CTA />
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingPage;